<template>
  <div id="app" class="app-background">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped>
.app-background {
  background: #f5f5f5;
  min-height: 100vh;
}
</style>
